import { z } from 'zod'
import { FormConfigLoader } from '@/lib/formConfigLoader'
import formYaml from './form.yml?raw'

const formConfig = FormConfigLoader.loadFormConfig(formYaml)
export const FORM_CONFIG = formConfig

export const ActivateDeviceFormSchema = z.object({
  networkCorridor: z.string().min(1, "Network Corridor is required"),
  networkSite: z.string().min(1, "Network Site is required"),
})

export type ActivateDeviceFormData = z.infer<typeof ActivateDeviceFormSchema>

export function transformToApiRequest(formData: ActivateDeviceFormData, deviceNumber: number) {
  return {
    provisioningInfo: {
      deviceNumber,
      networkCorridor: formData.networkCorridor, // Or networkCorridorNumber if int needed? Keeping as string per existing schema but provisionDevice uses parseInt. Let's check composer logic.
      // My schema has string, provisionDevice parsed ints. Let's assume strings for now or check if API needs numbers.
      // provisionDevice schema uses parseInt. My composer used simple value passing.
      // deviceDetail.md requirements says API endpoint 'sensenet/getNetworkCorridors' which usually returns objects with IDs.
      // Let's use string keys as in my schema for now and parse if needed or pass as is if form value is the name.
      // Wait, provisionDevice uses networkCorridorNumber.
      // My previous composer implementation used networkCorridorName as value and label.
      // Let's stick to what I had but structure the return object.
      networkSite: formData.networkSite,
      deviceProvisioningStatus: "requested",
      deviceProvisionRequestedDate: Math.floor(Date.now() / 1000),
    },
    device: {
      deviceNumber,
      deviceStatus: "live"
    }
  }
}
